import React from 'react';
import './App.css';

function App() {
  // Generate random positions for floating elements
  const generateFloatingElements = (count, type) => {
    return Array.from({ length: count }, (_, i) => ({
      id: `${type}-${i}`,
      left: Math.random() * 100,
      delay: Math.random() * 5,
      duration: 15 + Math.random() * 10,
      size: 0.5 + Math.random() * 1
    }));
  };

  const dollarBills = generateFloatingElements(12, 'dollar');
  const coins = generateFloatingElements(15, 'coin');
  const symbols = generateFloatingElements(8, 'symbol');

  return (
    <div className="app">
      {/* Animated Background Gradient */}
      <div className="background">
        <div className="shape shape1"></div>
        <div className="shape shape2"></div>
        <div className="shape shape3"></div>
      </div>

      {/* Floating Dollar Bills */}
      <div className="floating-money">
        {dollarBills.map((bill) => (
          <div
            key={bill.id}
            className="dollar-bill"
            style={{
              left: `${bill.left}%`,
              animationDelay: `${bill.delay}s`,
              animationDuration: `${bill.duration}s`,
              transform: `scale(${bill.size})`
            }}
          >
            <svg viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id={`dollarGradient-${bill.id}`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#d4af37" />
                  <stop offset="100%" stopColor="#f4e4a6" />
                </linearGradient>
              </defs>
              <rect width="100" height="50" rx="3" fill={`url(#dollarGradient-${bill.id})`} stroke="#d4af37" strokeWidth="1"/>
              <text x="50" y="30" fontSize="24" fill="#0a0a0a" textAnchor="middle" fontWeight="bold">$</text>
            </svg>
          </div>
        ))}
      </div>

      {/* Floating Coins */}
      <div className="floating-coins">
        {coins.map((coin) => (
          <div
            key={coin.id}
            className="coin"
            style={{
              left: `${coin.left}%`,
              animationDelay: `${coin.delay}s`,
              animationDuration: `${coin.duration}s`,
              transform: `scale(${coin.size})`
            }}
          >
            <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <radialGradient id={`coinGradient-${coin.id}`}>
                  <stop offset="0%" stopColor="#f4e4a6" />
                  <stop offset="100%" stopColor="#d4af37" />
                </radialGradient>
              </defs>
              <circle cx="20" cy="20" r="18" fill={`url(#coinGradient-${coin.id})`} stroke="#d4af37" strokeWidth="2"/>
              <text x="20" y="27" fontSize="18" fill="#0a0a0a" textAnchor="middle" fontWeight="bold">$</text>
            </svg>
          </div>
        ))}
      </div>

      {/* Floating Financial Symbols */}
      <div className="floating-symbols">
        {symbols.map((symbol, index) => (
          <div
            key={symbol.id}
            className="financial-symbol"
            style={{
              left: `${symbol.left}%`,
              animationDelay: `${symbol.delay}s`,
              animationDuration: `${symbol.duration}s`,
              transform: `scale(${symbol.size})`
            }}
          >
            {['€', '¥', '£', '₦', 'R', '₹', '฿', '₽'][index % 8]}
          </div>
        ))}
      </div>

      {/* Animated Stock Lines */}
      <div className="stock-lines">
        <svg className="stock-line" viewBox="0 0 200 100" preserveAspectRatio="none">
          <polyline
            points="0,80 40,60 80,70 120,40 160,50 200,30"
            fill="none"
            stroke="rgba(212, 175, 55, 0.3)"
            strokeWidth="2"
          />
        </svg>
        <svg className="stock-line stock-line-2" viewBox="0 0 200 100" preserveAspectRatio="none">
          <polyline
            points="0,50 40,70 80,45 120,60 160,35 200,55"
            fill="none"
            stroke="rgba(46, 204, 113, 0.2)"
            strokeWidth="2"
          />
        </svg>
      </div>

      {/* Particle Effect */}
      <div className="particles">
        {Array.from({ length: 30 }).map((_, i) => (
          <div
            key={`particle-${i}`}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${10 + Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>

      {/* Main Content - Just Logo and Tagline */}
      <div className="container">
        <div className="logo-section">
          <div className="logo">2AMI</div>
          <div className="tagline">African Asset Management & Investment</div>
          <div className="coming-soon">Coming Soon</div>
        </div>
      </div>
    </div>
  );
}

export default App;
